import React, { useState , useEffect} from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as store from 'store';
import Const from "../../../constants";
import APPLICATION_TYPE from "../../../constants/application-type";
import Http from "../../../http";
import Transition from "../../../utils/transition";
import Price from "../../../utils/price";
import {
  PaymentInfo,
  ShippingAddressInfo,
  FinalPriceInfo,
  Modal,
  Message,
  BULMA,
  FormatUtil,
  ShippingAddressModal,
  PaymentModal,
  HttpUtil, CookieUtil
} from '@graffer-inc/graffer-ui';
import EntryDetailInfo from '../../organisms/entry/entry-detail-info';
import PreSettingDone from '../../templates/pre-setting-done';
import ErrorHandler from "../../../utils/error-handler";
import { toast } from "react-toastify";
import * as jssha from "js-sha256";
import Analytics from "../../../analytics";
import Step from "../../organisms/entry/step";

const Main = ({priceTable, loginAccount, stampSubmitter, entries }) => {

  const formData = store.get(Const.STORAGE.FORM_DATA);

  const [corporateAddress, setCorporateAddress] = useState(null);
  const [corporateAddressSetByUser, setCorporateAddressSetByUser] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [isRequestingShippingAddress, setIsRequestingShippingAddress] = useState(true);
  const [isShippingAddressModalOpening, setIsShippingAddressModalOpening] = useState(false);
  const [card, setCard] = useState(null);
  const [isRequestingCard, setIsRequestingCard] = useState(true);
  const [isCardModalOpening, setIsCardModalOpening] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isConfirmModalOpening, setIsConfirmModalOpening] = useState(false);

  const fetchShippingAddress = async () => {
    setIsRequestingShippingAddress(true);
    await Http.fetchShippingAddress(res => {
      setIsRequestingShippingAddress(false);
      if (res.data.shippingAddresses && res.data.shippingAddresses.length > 0) {
        setShippingAddress(res.data.shippingAddresses[0]);
      }
    });
  };
  const fetchCard = async () => {
    setIsRequestingCard(true);
    await Http.fetchCard(res => {
      setIsRequestingCard(false);
      setCard(res.data.card);
    });
  };
  const searchCorporations = async (corporateId) => {
    setIsRequestingCard(true);
    await Http.searchCorporations(
      corporateId,
      res => setCorporateAddress(res.data.data[0].pref + res.data.data[0].city + res.data.data[0].street));
  };
  const fetchCorporateAddressSetByUser = async () => {
    await Http.fetchCorporateAddressSetByUser(
      res => setCorporateAddressSetByUser(res.data.corporateAddress ? res.data.corporateAddress.value : null));
  };
  useEffect(() => {
    fetchCorporateAddressSetByUser();
    fetchShippingAddress();
    fetchCard();
  }, []);
  useEffect(() => {
    searchCorporations(loginAccount.company.corporateId);
  }, [loginAccount]);

  if (!formData) {
    Transition.goTo('/entries/new');
    return null;
  }

  const entry = async () => {
    const {postalCode, address, addressStreet, addressOther, receiverName} = shippingAddress;
    setIsSubmitting(true);
    const amount = Price.getTotalPrice(priceTable, formData);
    const utm = CookieUtil.get(Const.COOKIE.UTM);
    const body =
    {
      certPeriod: Number(formData.certPeriod),
      amount: amount,
      isRegistryCertsRegistration: formData.isRegistryCertsRegistration,
      isWithRevenueStamp: formData.isWithRevenueStamp,
      applicationType: formData.applicationType,
      postalCode: postalCode,
      address: address + (addressStreet || '') + (addressOther ? ` ${addressOther}` : ''),
      receiverName: receiverName,
      attorneyName: formData.isAttorneyApplication ? formData.attorneyName : null,
      attorneyAddress: formData.isAttorneyApplication ? formData.attorneyAddress : null,
      cardId: card.id,
      utmSource: utm ? utm.source : null,
      utmMedium: utm ? utm.medium : null,
      utmCampaign: utm ? utm.campaign : null,
    };
    await Http.entry(
      body,
        res => {
        setIsSubmitting(false);
          Analytics.entryModalToComplete(!entries || entries.length === 0);
          Analytics.sendLog({
            event: "el_cert_order_comp",
            user_id: jssha.sha256(loginAccount.user.userId),
            cert_period: Number(formData.certPeriod),
          });
          CookieUtil.remove(Const.COOKIE.UTM);
          toast.success("申し込みが完了しました。取得サポートキットの到着をお待ちください。");
        Transition.goTo(`/entries/${res.data.entry.id}`);
      },
      err => {
        setIsSubmitting(false);
        if (err.response && err.response.status === 400 && err.response.data && err.response.data.msg === 'charge failed') {
          toast.error("無効なカードです。お支払い情報を更新してください。");
          return;
        }
        ErrorHandler.common(err.response.status);
      }
    );
  };

  const priceInfos = !priceTable ? [] : [
    {
      name: `${APPLICATION_TYPE.name(formData.applicationType)}プラン料金(税抜)`,
      count: 1,
      price: APPLICATION_TYPE.CODE.WINDOW === formData.applicationType ? priceTable.price : priceTable.deliveryPrice,
    },
  ];
  if (formData.isWithRevenueStamp && priceTable) {
    priceInfos.push({
      name: '収入印紙セット料金(税抜)',
      count: 1,
      price: Price.getRevenueStampPrice(formData.certPeriod, priceTable.revenueStampFeeRate),
    });
  }

  return (
    <PreSettingDone>
      <div className="container">
        <p className="is-size-3 has-text-weight-bold">申込内容の確認</p>
        <div style={{padding: '10px 0 15px 0'}}>
          <Step />
        </div>
        <Message color={BULMA.COLOR.INFO}>
          <p><span className="has-text-weight-bold">お申し込みを確定いただくと、ご指定のお届け先に取得サポートキットを発送します。<span className="is-highlight">取得サポートキットの到着をお待ちください。</span></span></p>
          <p>到着目安は
            <a href="https://help.graffer.jp/article/102-article" target="_blank" rel="noopener noreferrer">こちら</a>
            をご覧ください。
          </p>
          {
            !formData.isWithRevenueStamp && (
              <p><span className="has-text-weight-bold is-highlight">サービスの料金とは別に、ご自身で発行手数料分の収入印紙をご準備いただく必要があります。ご認識の上、お申し込みください。</span></p>
            )
          }
        </Message>
        {
          ((!shippingAddress || !card) && !isRequestingShippingAddress && !isRequestingCard) && (
            <Message color={BULMA.COLOR.WARNING}>
                {
                  !shippingAddress && (<p><span className="has-text-weight-bold">
                    {/* eslint-disable-next-line */}
                    <a onClick={() => setIsShippingAddressModalOpening(true)}>お届け先を登録</a>
                    してください。</span></p>)
                }
                {
                  (shippingAddress && !card) && (<p><span className="has-text-weight-bold">
                    {/* eslint-disable-next-line */}
                    <a onClick={() => setIsCardModalOpening(true)}>お支払い方法を登録</a>
                    してください。</span></p>)
                }
            </Message>
          )
        }
        <div style={{ paddingBottom: '15px' }}>
          <p className="is-size-7 has-text-grey">
            「請求を確定する」ボタンを押すことで
            <a href="https://graffer.jp/legal/terms-e-cert" target="_blank" rel="noopener noreferrer">利用規約</a>
            、
            <a href="https://graffer.jp/legal/privacy-policy" target="_blank" rel="noopener noreferrer">プライバシーポリシー</a>
            、
            <a href="https://graffer.jp/legal/scta-e-cert" target="_blank" rel="noopener noreferrer">特定商取引法に基づく表記</a>
            に同意の上お申し込みされたことになります。
          </p>
        </div>
        <div className="columns">
          <div className="column is-8">
            <div className="columns">
              <div className="column is-8">
                <ShippingAddressInfo
                  canChange
                  isLoading={isRequestingShippingAddress}
                  shippingAddress={shippingAddress}
                  className="flat-box"
                  onEdit={() => setIsShippingAddressModalOpening(true)}
                />
              </div>
              <div className="column is-4">
                <PaymentInfo
                  canChange
                  isLoading={isRequestingCard}
                  brand={card ? card.brand : ''}
                  last4={card ? card.last4 : ''}
                  className="flat-box"
                  onEdit={() => setIsCardModalOpening(true)}
                />
              </div>
            </div>
            <div className="columns">
              <div className="column">
                <EntryDetailInfo entry={formData} canEdit />
              </div>
            </div>
          </div>
          <div className="column is-4">
            <div>
              <FinalPriceInfo
                tax={priceTable ? priceTable.tax : 0}
                priceInfos={priceInfos}
                isLoading={!priceTable}
              />
              <p style={{margin: '10px 0'}} className="is-size-7 has-text-grey">
                サービス利用料とは別に管轄登記所の窓口で、電子証明書の証明期間に記載の発行手数料の支払いが必要になりますのでご認識の上、お申し込みください。
                <br/>
                デジタルコンテンツの特性上、取得サポートキットの発送後のキャンセル・返金についてはお受けできません。取得サポートキット発送前の注文キャンセル・返金の対応は可能です。
                <br/>
                詳細の条件・お問い合わせ先は
                <a href="https://graffer.jp/legal/scta-e-cert" target="_blank" rel="noopener noreferrer">特定商取引法に基づく表記</a>
                の『返金について』をご確認ください。
              </p>
              <button
                onClick={() => {
                  Analytics.entryConfirmToModal(!entries || entries.length === 0);
                  setIsConfirmModalOpening(true);
                }}
                disabled={!shippingAddress || !card || isSubmitting}
                className={`button is-accent is-rounded is-fullwidth ${isSubmitting && 'is-loading'}`}
              >
                {
                  !isRequestingShippingAddress && !shippingAddress ? 'お届け先を登録してください'
                    : !isRequestingCard && !card ? 'お支払い方法を登録してください' : '申し込みを確定する'
                }
              </button>
            </div>
          </div>
        </div>
      </div>
      {
        isConfirmModalOpening && (
          <Modal onClose={() => !isSubmitting && setIsConfirmModalOpening(false)}>
            <div className="card" style={{ padding: "20px 30px" }}>
              <Message color={BULMA.COLOR.WARNING}>
                <p>こちらの法人及び印鑑提出者情報を元に申し込みを受け付けます。</p>
                <p><span className="has-text-weight-bold is-highlight">設定に誤りがある場合、管轄登記所で申請承認されない場合があります。</span>今一度内容を確認してください。</p>
              </Message>
              <div style={{padding: '10px 10px 50px 10px'}}>
                <ul className="is-flex">
                  <li style={{minWidth: '140px'}}><span className="has-text-weight-bold" style={{padding: '0 5px 0 0'}}>法人</span><Link className="is-size-7" to="/settings/company?to=/entries/confirm">変更</Link></li>
                  <li>
                    <p>{loginAccount.company.companyName}</p>
                    <p>{loginAccount.company.corporateId} / {FormatUtil.corporateNumber(loginAccount.company.corporateId)}</p>
                    <p>{corporateAddressSetByUser || corporateAddress}</p>
                    {
                      corporateAddressSetByUser ? (
                        <p className="is-size-7 has-text-grey">本店所在地が登記されたものであることを、今一度ご確認ください。</p>
                      ) : (
                        <p className="is-size-7 has-text-grey">本店所在地は国税庁のシステムから取得しています。ほとんどの場合、登記どおりの本店所在地となりますが、変更が必要な場合があります。</p>
                      )
                    }
                  </li>
                </ul>
                <br/>
                <ul className="is-flex">
                  <li style={{minWidth: '140px'}}><span className="has-text-weight-bold" style={{padding: '0 5px 0 0'}}>印鑑提出者</span><Link className="is-size-7" to="/settings/stamp-submitter?to=/entries/confirm">変更</Link></li>
                  <li>
                    <p>{stampSubmitter.name}</p>
                    <p>{stampSubmitter.qualification}</p>
                    <p>{FormatUtil.date(stampSubmitter.birthday)}<span className="is-size-7" style={{padding: '0 0 0 5px'}}>生まれ</span></p>
                    <p className="is-size-7">生年月日を<span className="is-size-6" style={{padding: '0 5px'}}>{stampSubmitter.typeOfCalendar}</span>で届出</p>
                  </li>
                </ul>
              </div>
              <div className="is-flex">
                <button
                  onClick={async () => {
                    await entry();
                    setIsConfirmModalOpening(false);
                  }}
                  disabled={isSubmitting}
                  className={`button is-accent is-rounded is-fullwidth ${isSubmitting && 'is-loading'}`}
                >
                  確定する
                </button>
                <div style={{ padding: "0px 5px" }}></div>
                <button
                  onClick={() => setIsConfirmModalOpening(false)}
                  disabled={isSubmitting}
                  className="button is-text is-rounded is-fullwidth"
                >
                  キャンセル
                </button>
              </div>
            </div>
          </Modal>
        )
      }
      {
        isShippingAddressModalOpening && (
          <ShippingAddressModal
            initialFormData={shippingAddress}
            onSuccess={async () => {
              toast.success('お届け先を登録しました。');
              await fetchShippingAddress();
            }}
            onNotExistPostalCode={() => toast.error('存在しない郵便番号です。郵便番号を確認してください。')}
            onFail={() => {
              toast.error('お届け先の登録に失敗しました。画面を更新して再度操作してください。');
            }}
            onClose={() => setIsShippingAddressModalOpening(false)}
          />
        )
      }
      {
        isCardModalOpening && (
          <PaymentModal
            onSuccess={async () => {
              toast.success('お支払い情報を登録しました。');
              await fetchCard();
            }}
            onFail={(e) => {
              toast.error(HttpUtil.createApiErrorMessage(e));
            }}
            onClose={() => setIsCardModalOpening(false)}
          />
        )
      }
    </PreSettingDone>
  )
};

export default connect(
  store => ({
    priceTable: store.user.priceTable,
    loginAccount: store.user.loginAccount,
    stampSubmitter: store.user.stampSubmitter,
    entries: store.user.entries,
  }),
)(Main);